<div>
  <div>
    Возможные типы сеток (выбор приведёт к автоматическому формированию сетки):
  </div>
  <div
    class="containerOfGridTypes"
  >
    <div
      class="containerOfSingleEliminations"
    >
      <div
        id='se'
        class='gridTypeLineStyle'
        (click)="gridTypeClickHandler($event)"
      >
        Олимпийка на {{maximalAmountOfPlayers}}
      </div>
    </div>
    <div
      class="containerOfDoubleEliminations"
    >
      <div
        *ngFor="let key of doubleEliminationsMap.keys()"
        id="{{key}}"
        class="gridTypeLineStyle"
        (click)="gridTypeClickHandler($event)"
      >
        {{maximalAmountOfPlayers}} на {{doubleEliminationsMap.get(key)}}
      </div>

    </div>
  </div>
</div>
